var _path, _path2, _path3, _path4;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPinFilled = function SvgPinFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7038 18.8029L14.5541 19.9099C13.5791 20.8486 12.032 20.834 11.075 19.8769L4.89193 13.772C3.90068 12.8059 3.8904 11.2159 4.86906 10.237L6.02109 9.08477C6.54982 8.55594 7.28866 8.29347 8.03251 8.37021L9.84274 8.55697L12.3329 6.06685C11.9067 3.70098 15.151 1.62205 16.9653 3.43627L21.3537 7.82466C23.1505 9.62142 21.1251 12.8377 18.7755 12.466L16.265 14.9765L16.4514 16.7547C16.5312 17.5162 16.2554 18.2719 15.7038 18.8029Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9871 10.9914L2.3837 20.5947C1.89554 21.0828 1.89554 21.8743 2.38369 22.3624C2.87184 22.8506 3.6633 22.8506 4.15146 22.3624L13.7548 12.7591C14.243 12.271 14.243 11.4795 13.7549 10.9914C13.2667 10.5032 12.4752 10.5032 11.9871 10.9914Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7038 18.8029L14.5541 19.9099C13.5791 20.8486 12.032 20.834 11.075 19.8769L4.89193 13.772C3.90068 12.8059 3.8904 11.2159 4.86906 10.237L6.02109 9.08477C6.54982 8.55594 7.28866 8.29347 8.03251 8.37021L9.84274 8.55697L12.3329 6.06685C11.9067 3.70098 15.151 1.62205 16.9653 3.43627L21.3537 7.82466C23.1505 9.62142 21.1251 12.8377 18.7755 12.466L16.265 14.9765L16.4514 16.7547C16.5312 17.5162 16.2554 18.2719 15.7038 18.8029Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1642 11.1681L2.56086 20.7714C2.17033 21.162 2.17033 21.7951 2.56085 22.1856C2.95137 22.5762 3.58454 22.5762 3.97507 22.1857L13.5785 12.5824C13.969 12.1918 13.969 11.5587 13.5785 11.1682C13.1879 10.7776 12.5548 10.7776 12.1642 11.1681Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pin-filled.a8a169ae.svg";
export { ForwardRef as ReactComponent };